import axiosPrivate from "@services/axiosPrivate"
import { FIND_PATIENT } from "src/constants"

export const findPatient = (data) =>
  axiosPrivate.post(FIND_PATIENT, data, { withCredentials: true })
